export type Breakpoints = {
  laptop: number;
  tablet: number;
  mobile: number;
};

const breakpoints: Breakpoints = {
  laptop: 1024,
  tablet: 768,
  mobile: 600,
};

type BaseMedia = {
  [K in keyof Breakpoints]: string;
};

export const baseMedia: BaseMedia = {
  laptop: `@media (max-width: ${breakpoints.laptop}px)`,
  tablet: `@media (max-width: ${breakpoints.tablet}px)`,
  mobile: `@media (max-width: ${breakpoints.mobile}px)`,
};

export default baseMedia;
